import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'app/_services/notification.service';
import { WorkflowItemService } from 'app/_services/workflow-items.service';

@Component({
  selector: 'approve-cancelled-availabilty-modal',
  templateUrl: './approve-cancelled-availabilty-modal.component.html'
})
export class ApproveCancelledAvailabilityModalComponent implements OnInit {
  @Input() assetId: any;
  @Input() scheduleItem: any;

  public form: FormGroup;
  public validationErrors: any[] = [];
  public minDate = new Date();
  public saveInProgress = false;
  public endTimeShowChangeOccurred = false;
  public showRejectionForm = false;

  constructor(
    private activeModal: NgbActiveModal,
    private workflowItemService: WorkflowItemService,
    private notificationService: NotificationService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.minDate.setUTCHours(0, 0, 0, 0);

    this.form = this.formBuilder.group({
      scheduledStartTime: new FormControl(new Date(this.scheduleItem.startTime)),
      scheduledEndTime: new FormControl(new Date(this.scheduleItem.endTime)),
      reason: new FormControl(this.scheduleItem.reason, [Validators.maxLength(100)]),
    });
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public reject() {
    this.saveInProgress = true;

    let body = {
      status: 'REJECTED',
    };

    this.workflowItemService.approveOrRejectItem(this.scheduleItem.cancelledItem.id, body).subscribe(() => {
      this.notificationService.notify('success', 'Success', 'Request rejected');
      this.activeModal.close('refresh');
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', `Couldn't save rejection of request`, `Try again later`);
      this.saveInProgress = false;
    });
  }

  public approve() {
    this.saveInProgress = true;
    let body = {
      status: 'APPROVED',
    };

    this.workflowItemService.approveOrRejectItem(this.scheduleItem.cancelledItem.id, body).subscribe(() => {
      this.notificationService.notify('success', 'Success', 'Request for removal complete');
      this.activeModal.close('refresh');
    }, error => {
      console.error(error);
      if (error && error.error && error.error.title) {
        this.notificationService.notify('danger', `Couldn't save removal`, `${error.error.title}`);
      } else {
        this.notificationService.notify('danger', `Couldn't save removal`, `Try again later`);
      }
      this.saveInProgress = false;
    });
  }
}
